module.exports = __webpack_public_path__ + "img/reference-hotel-schlosshofen.c2ceb13f.jpg";